import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { type HsmKeyTypeMappingObj } from '../services/getFilteredActiveDeviceKeyMappingsList'

export interface HsmKeyTypeMappingListState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  data: HsmKeyTypeMappingObj | null
}

const initialState: HsmKeyTypeMappingListState = {
  isLoading: false,
  error: null,
  httpStatus: 0,
  data: null
}

export const getFilteredActiveDeviceKeyMappingListSlice = createSlice({
  name: 'filteredKeyTypeMappingsList',
  initialState,
  reducers: {
    hsmKeyTypeMappingListLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        data: null
      }
    },
    hsmKeyTypeMappingListUpdateAction: (state, action: PayloadAction<{ data: HsmKeyTypeMappingObj, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        data: action.payload.data
      }
    },
    hsmKeyTypeMappingListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        data: null
      }
    }
  }
})

export const {
  hsmKeyTypeMappingListLoadingAction,
  hsmKeyTypeMappingListUpdateAction,
  hsmKeyTypeMappingListErrorAction
} = getFilteredActiveDeviceKeyMappingListSlice.actions

export default getFilteredActiveDeviceKeyMappingListSlice.reducer
